<template>
    <div>
        <view-customer ref="view-customer-ref" :isCustomerVisible="isCustomerVisible"
            @setNewCustomerForm="setCustomer()"></view-customer>
        <ReportsDialog ref="reportsDialog" :report-list="reportList" :query="reportQuery" />
        <import-form :subject="$translate('customers')" v-model="importModal" @cancel="hideModal()" :fields="customerFields"
            :upload-record="uploadCustomerRecord" settings-key-name="customerUploadKey"></import-form>

        <customer-table :title="$translate('customers')" ref="customertableRef" :lifecycleStages="lifecycleStages" :customerAgents="customerAgents"
            :customerGroups="customerGroups" :customerSegments="customerSegments">
            <page-actions :buttons-actions="buttonActions" control-class="float-center" control-size="sm" />
        </customer-table>
    </div>
</template>
<script>
import CustomerTable from './CustomerTable'
import ImportForm from '@/components/ImportForm.vue'
import ReportsDialog from '@/components/ReportsDialog'
import ViewCustomer from '@/views/Customers/ViewCustomer'
import PageActions from '@/components/PageActions.vue'

import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import { templates } from '@/exports/jsreport_templates'
import plus from '@/assets/images/icon/gradient-add.svg'
import upload from '@/assets/images/icon/export.svg'
import download from '@/assets/images/icon/import.svg'

export default {
    name: 'customers',
    components: {
        CustomerTable,
        ImportForm,
        PageActions,
        ReportsDialog,
        ViewCustomer,
    },
    mixins: [popupMixins, permissionsMixins],
    data: () => {
        return {
            componentName: 'Customer',
            loading: false,
            importModal: false,
            isCustomerVisible: false,
            reportQuery: {},
        }
    },
    computed: {
        customerFields() {
            return [
                { name: 'code', label: this.$translate('code'),  required: true, type: 'text' },
                { name: 'name', label: this.$translate('name'), required: true, type: 'text' },
                { name: 'email', label: this.$translate('email'), required: false, type: 'email' },
                { name: 'address1', label: this.$translate('address1'), required: false, type: 'text' },
                { name: 'address2', label: this.$translate('address2'), required: false, type: 'text' },
                { name: 'city', label: this.$translate('city'), required: false, type: 'text' },
                { name: 'country_code', label: this.$translate('country_code'), required: false, type: 'text' },
                { name: 'customer_group', label: this.$translate('customer_group'), required: false, type: 'text' },
                { name: 'customer_segment', label: this.$translate('customer_segment'), required: false, type: 'text' },
                { name: 'lifecycle_stage', label: this.$translate('lifecycle_stage'), required: false, type: 'text' },
                { name: 'customer_agent', label: this.$translate('customer_agent'), required: false, type: 'text' },
                { name: 'remarks', label: this.$translate('remark'), required: false, type: 'text' },
            ]
        },
        buttonActions() {
            const actions = []
            if (this.hasPermissionCreate) {
                actions.push(
                    {
                        action: () => this.createNewOrder(),
                        icon: 'plus-circle',
                        img: plus,
                        variant: 'blue-icon',
                        class: 'btn-blue-icon me-2',
                        tooltip: this.$translate('new'),
                    },
                    {
                        action: () => this.importOrders(),
                        icon: 'upload',
                        img: download,
                        variant: 'blue-icon',
                        class: 'btn-blue-icon me-2',
                        tooltip: this.$translate('import'),
                    }
                )
            }
            if (this.hasPermissionView) {
                actions.push({
                    action: () => this.showReportsDialog(),
                    icon: 'download',
                    img: upload,
                    variant: 'blue-icon',
                    class: 'btn-blue-icon',
                    tooltip: this.$translate('export'),
                })
            }
            return actions
        },
        reportList() {
            return [
                {
                    id: 'customer-report',
                    value: templates.RPT_SVR_CUS_DET_TEMPLATE,
                    extension: 'xlsx',
                    name: 'customer-report',
                },
            ]
        },

        customerSegments() {
            console.log(
                'this.$store.state.customerSegments.customer_segments',
                this.$store.state.customerSegments.customer_segments
            )
            return this.$store.state.customerSegments.customer_segments
        },
        lifecycleStages() {
            console.log(
                'this.$store.state.customerSegments.customer_segments',
                this.$store.state.customerSegments.customer_segments
            )
            return this.$store.state.lifecycleStage.items
        },
        customerGroups() {
            return this.$store.state.customerGroups.customer_groups
        },
        customerAgents() {
            return this.$store.state.customerAgents.customer_agents
        },
    },
    created() {
        
    },

    methods: {
        showReportsDialog() {
            this.reportQuery =
                this.$refs.customertableRef &&
                this.$refs.customertableRef.getReportQuery()
            this.$nextTick(() => {
                console.log('reportQuery:', this.reportQuery)
                this.$refs.reportsDialog.show()
            })
        },
        createNewOrder() {
            const id = 0
            this.$store.state.customers.item = null
            this.$router.push({ params: { id }, name: 'viewCustomer' })
        },
        importOrders() {
            this.importModal = true
        },
        hideModal() {
            this.$refs.customertableRef.doSearch()
        },

        customerCreated() {
            this.genericToast(
                this.componentName,
                'Created',
                'success',
                'Customer successfully created'
            )
            // this.doToast('Customer Action!', 'Customer Created.', 'success')
            this.$refs.customertableRef.doSearch()
        },
        customerImported() {
            this.genericToast(
                this.componentName,
                'Imported',
                'success',
                'Customers successfully imported'
            )
            // this.doToast('Customer Action!', 'Customer Imported.', 'success')
            this.$refs.customertableRef.doSearch()
        },

        async setGeocode(location) {
            try {
                const { latitude, longitude } = await this.$store.dispatch(
                    'locations/geocodeAddress',
                    location
                )
                console.log('geocode', { latitude, longitude })
                location = { ...location, ...{ latitude, longitude } }
                return true
            } catch (err) {
                return false
            }
        },

        async uploadCustomerRecord(
            dataRecord,
            statusRecord,
            { check, field, message },
            statuses,
            setLoading
        ) {
            let {
                code,
                name,
                email,
                customer_group,
                customer_segment,
                customer_agent,
                remarks,
                lifecycle_stage,
                address1,
                address2,
                city,
                country_code,
            } = dataRecord

            statusRecord.status = statuses.CHECKING
            if (check == 1) {
                city = city || 'Kingston'
                country_code = country_code || 'JM'
                let location = { address1, address2, city, country_code }
                console.log('netering ')
                setLoading(true)
                // try to find the location

                try {
                    statusRecord.status = statuses.GEOCODING
                    const isValidLocation = await this.setGeocode(location)
                    statusRecord.status = statuses.SAVING
                    await this.$store.dispatch('customers/uploadCustomer', {
                        code,
                        name,
                        email,
                        customer_group,
                        lifecycle_stage,
                        customer_segment,
                        customer_agent,
                        remarks,
                        location,
                    })
                    statusRecord.status = isValidLocation
                        ? statuses.COMPLETE
                        : statuses.INVALID_LOCATION
                } catch (err) {
                    console.warn(err)
                    statusRecord.error_list =
                        typeof err.message == 'string'
                            ? [err.message]
                            : Object.entries(err.message)
                    statusRecord.status = statuses.ERROR
                } finally {
                    setLoading(false)
                }
            } else {
                // set error status if the name or email fails validation
                statusRecord.status = statuses.ERROR
                if (check == 0) {
                    statusRecord.error_list = [[field, [message]]]
                }
                if (check == -1) {
                    statusRecord.error_list = [[field, [message]]]
                }
            }
        },
    },
}
</script>
<style></style>
